/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type careTeam_PlanCareTeam$ref = any;
export type careTeam_removeCareTeamMember_MutationVariables = {|
  planId: any,
  memberId: any,
|};
export type careTeam_removeCareTeamMember_MutationResponse = {|
  +careTeamMemberMutation: ?{|
    +removeCareTeamMember: ?{|
      +$fragmentRefs: careTeam_PlanCareTeam$ref
    |}
  |}
|};
export type careTeam_removeCareTeamMember_Mutation = {|
  variables: careTeam_removeCareTeamMember_MutationVariables,
  response: careTeam_removeCareTeamMember_MutationResponse,
|};
*/


/*
mutation careTeam_removeCareTeamMember_Mutation(
  $planId: UUID!
  $memberId: UUID!
) {
  careTeamMemberMutation {
    removeCareTeamMember(planId: $planId, memberId: $memberId) {
      ...careTeam_PlanCareTeam
      id
    }
  }
}

fragment careTeam_PlanCareTeam on Plan {
  id
  careTeamMembers {
    id
    name
    primary
    role {
      id
      code
      value
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "memberId",
    "variableName": "memberId"
  },
  {
    "kind": "Variable",
    "name": "planId",
    "variableName": "planId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "careTeam_removeCareTeamMember_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removeCareTeamMember",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "careTeam_PlanCareTeam"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "careTeam_removeCareTeamMember_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removeCareTeamMember",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareTeamMember",
                "kind": "LinkedField",
                "name": "careTeamMembers",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "29d3302b5272486d1b4472030897f4e2",
    "id": null,
    "metadata": {},
    "name": "careTeam_removeCareTeamMember_Mutation",
    "operationKind": "mutation",
    "text": "mutation careTeam_removeCareTeamMember_Mutation(\n  $planId: UUID!\n  $memberId: UUID!\n) {\n  careTeamMemberMutation {\n    removeCareTeamMember(planId: $planId, memberId: $memberId) {\n      ...careTeam_PlanCareTeam\n      id\n    }\n  }\n}\n\nfragment careTeam_PlanCareTeam on Plan {\n  id\n  careTeamMembers {\n    id\n    name\n    primary\n    role {\n      id\n      code\n      value\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4e4b301fbcc26efc98079913c96f8b31';

module.exports = node;
